/* eslint-disable */
/* @flow */

import * as React from 'react'
import { Image, TouchableWithoutFeedback, View } from 'react-native'
import Images from "../Themes/Images"

import BadgeButton from './BadgeButton'


import styles from './Styles/ProfilePhotoStyles'



const ProfilePhoto = ({ children, onPress, path }) => {
 
  const source = path ? { uri: path, cache: 'reload' } : Images.noAvatar

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View style={styles.container}>
        <Image resizeMode="center" source={source} style={styles.image} />
        <View style={styles.badgeButton}>{children}</View>
      </View>
    </TouchableWithoutFeedback>
  )
}

export default ProfilePhoto
